import { Component, Input } from '@angular/core';
import { SkeletonLoaderLayout } from '../types';

@Component({
    selector: 'lib-filter-list-skeleton',
    templateUrl: './filter-list-skeleton.component.html',
    styleUrl: './filter-list-skeleton.component.css',
    standalone: false
})
export class FilterListSkeletonComponent {
  @Input() topFilters = false;
  @Input() layout: SkeletonLoaderLayout;
  // When true, renders only the item placeholders (no search/filter header) - used for the infinite scroll "load more" indicator
  @Input() itemsOnly = false;
}
